/**
 * API клієнт для ref.pos_workstations (Порція Роздріб.2/5a).
 * Backend: /api/v1/retail/pos-workstations. Permissions: retail.workstation.manage.
 */
import { api } from './client';
import type { Page } from './catalogs';

export type WorkstationType = 'desktop' | 'mobile' | 'tablet';

export interface PosWorkstation {
  id: string;
  organization_id: string;
  code: string;
  name: string;
  description: string | null;
  workstation_type: WorkstationType;
  sales_channel_id: string | null;
  pos_provider_id: string | null;
  warehouse_id: string;
  cash_register_id: string | null;
  default_price_group_id: string | null;
  fiscal_registration_number: string | null;
  is_active: boolean;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface PosWorkstationCreate {
  organization_id: string;
  code: string;
  name: string;
  description?: string | null;
  workstation_type?: WorkstationType;
  sales_channel_id?: string | null;
  pos_provider_id?: string | null;
  warehouse_id: string;
  cash_register_id?: string | null;
  default_price_group_id?: string | null;
  fiscal_registration_number?: string | null;
  is_active?: boolean;
  comment?: string | null;
}

export type PosWorkstationUpdate = Partial<Omit<PosWorkstationCreate, 'organization_id'>>;

export const retailPosWorkstations = {
  list: (params?: { organization_id?: string; is_active?: boolean; limit?: number; offset?: number }) =>
    api.get<Page<PosWorkstation>>('/retail/pos-workstations', { params }).then((r) => r.data),
  get: (id: string) => api.get<PosWorkstation>(`/retail/pos-workstations/${id}`).then((r) => r.data),
  create: (payload: PosWorkstationCreate) =>
    api.post<PosWorkstation>('/retail/pos-workstations', payload).then((r) => r.data),
  update: (id: string, payload: PosWorkstationUpdate) =>
    api.patch<PosWorkstation>(`/retail/pos-workstations/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/retail/pos-workstations/${id}`).then(() => undefined),
};
